import axios, { AxiosRequestConfig } from 'axios';

import { AxiosServiceResponse, PagedList } from 'interfaces/general';

const instance = axios.create({
  baseURL: `${process.env.INSIGHT_SERVICE_ENDPOINT}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

export enum TypeComponentTemplate {
  short = 'shortAnswer',
  paragraph = 'paragraph',
  linearScale = 'linearScale',
  severalOptions = 'severalOptions'
}

export enum TypeItemsCostum {
  itemNumerText = 1,
  itemText = 'SingleLine',
  itemNumerSelect = 5,
  itemSelect = 'SelectionList',
  itemNumerNumeric = 3,
  itemNumeric = 'Numeric',
  itemNumerDate = 4,
  itemDate = 'DateTime',
  itemNumerTextArea = 2,
  itemTextArea = 'MultiLine'
}
export interface IQuestionsTemplate {
  label: string;
  isRequired?: boolean;
  orderItem: number;
  options?: string;
  typeComponent?: TypeComponentTemplate;
  maxLenght?: number;
  idSurveyQuestion?: number;
  enabled?: boolean;
}

export interface ISurveyTemplate {
  title: string;
  description?: string;
  idTemplate?: number;
  enabled?: boolean;
  questionsTemplate: IQuestionsTemplate[];
}

export interface AnswersVaue {
  value: string;
  idSurveyQuestion: number;
}
export interface SaveanswerSurvey {
  idTicket: number;
  answersVaue: AnswersVaue[];
}

export interface ParamsSurvey {
  OnlyEnabled?: boolean;
  PageNumber?: number;
  descending?: boolean;
  OrderColumn?: string;
  PageSize?: number;
  text?: string;
  IsExport?: boolean;
  IdSurveyTemplate?: number;
}

export interface SurveyTemplatesResponse {
  enabled?: boolean;
  idSurveyTemplate: number;
  title: string;
  description: string;
  surveyQuestionsTemplate: IQuestionsTemplate[];
}

export interface ISurveyReport {
  idSurvey: number;
  name: string;
  createdDate: Date | string;
  status: boolean | string;
}

export interface ISurveyAsnwered {
  idSurvey: number;
  user: string;
  titleSurvey: string;
  descriptionSurvey: string;
  dateResponse: Date | string;
}

export interface ItemReport {
  type: string;
  question: string;
  answers: {
    name: string;
    value: string | number;
  }[];
}
export interface ISurveyDetail {
  items: ItemReport[];
}

export interface ISurveyAnsweredDetail {
  valueResponse: string | number;
  questions: IQuestionsTemplate[];
}
export interface KPI {
  id?: number;
  name: string;
  category: string;
  description: string;
  formula: string;
  groupId: number;
  cycle: string;
  startDate: string;
  endDate: string;
  parameterList: ParameterList[];
  stateList: StateList[];
  enabled?: boolean;
}

export interface ParameterList {
  parameterId: number;
  parameterName?: string;
  filter: string;
  code: string;
  filterData: [
    {
      id: number;
      name: string;
    }
  ];
}

export interface StateList {
  name: string;
  hexColor: string;
  minLimit: number;
  maxLimit: number;
}

export interface KPIGroup {
  id: number;
  name: string;
  enabled: boolean;
}

export interface KPIGeneralSearch {
  id: number;
  name: string;
  description: string;
  category: string;
  groupName: string;
  cycle: string;
  enabled: boolean;
  pageNumber: number;
  pageSize: number;
  orderColumn: string;
  descending: boolean;
  text: string;
  isExport: boolean;
}

export interface KPIFilter {
  parameterFilterId: number;
  filter: string;
}

export interface KPIParameter {
  id: number;
  name: string;
  description: string;
  parameterFilterId: number;
  enabled: boolean;
}

export interface KPIResult {
  cycle: number;
  result: number;
  cycleName: string;
  id?: string;
}

export default {
  instance,
  kpi: {
    /**
     * Agrega un kpi
     *
     * @tags KPI
     * @name add
     * @request POST:/api/v1/KPI
     * @secure
     */
    add: (data: KPI, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/KPI`,
        method: 'POST',
        data,
        ...config
      }),

    update: (data: KPI, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/KPI`,
        method: 'PUT',
        data,
        ...config
      }),

    /*
     * Elimina un KPI
     *
     * @tags KPI
     * @name delete
     * @request DELETE:/api/v1/KPI/{id}
     * @secure
     * */
    delete: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/KPI/${id}`,
        method: 'DELETE',
        ...config
      }),

    /**
     * Búsqueda de KPIS
     *
     * @tags KPI
     * @name generalSearch
     * @request GET:/api/v1/KPI/GeneralSearch
     * @secure
     */
    generalSearch: (
      params: KPIGeneralSearch,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<KPI>>>({
        url: `/KPI/GeneralSearch`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * Evalúa un KPI
     *
     * @tags KPI
     * @name evaluate
     * @request POST:/api/v1/KPI/GetResults/{id}
     * @secure
     */
    getResults: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<KPIResult[]>>({
        url: `/KPI/GetResults/${id}`,
        method: 'GET',
        ...config
      })
  },
  kpiGroup: {
    /**
     * No description
     *
     * @tags KPIGroup
     * @name kpiGroup
     * @request GET:/api/v1/KPIGroup
     * @secure
     */
    kpiGroup: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<KPIGroup[]>>({
        url: `/KPIGroup`,
        method: 'GET',
        ...config
      })
  },
  survey: {
    /**
     *  Obtiene el all template
     *
     * @tags Survey
     * @name getTemplate
     * @request GET: /api/v1/Survey/templates/group
     * @secure
     */
    getAllTemplate: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<[]>>({
        url: `/Survey/templates/group`,
        method: 'GET',
        ...config
      }),
    /**
     *  Obtiene un template por id
     *
     * @tags Survey
     * @name getTemplateById
     * @request GET: /api/v1/Survey/TemplateById/{id}
     * @secure
     */
    getTemplateById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<SurveyTemplatesResponse>>({
        url: `/Survey/TemplateById/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     *  Obtiene un template por TemplateByIdTicket
     *
     * @tags Survey
     * @name getTemplateByIdTicket
     * @request GET: /api/v1/Survey/TemplateByIdTicket/{id}
     * @secure
     */
    getTemplateByIdTicket: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<SurveyTemplatesResponse>>({
        url: `/Survey/TemplateByIdTicket/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     *  Crea un template
     *
     * @tags Survey
     * @name createTemplate
     * @request POST: /api/v1/Survey/template
     * @secure
     */
    createTemplate: (data: ISurveyTemplate, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<[]>>({
        url: `/Survey/template`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     *  Contestar encuesta
     *
     * @tags Survey
     * @name SaveanswerSurvey
     * @request POST: /api/v1/Survey
     * @secure
     */
    SaveanswerSurvey: (
      data: SaveanswerSurvey,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<[]>>({
        url: `/Survey`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     *  Actualiza un template
     *
     * @tags Survey
     * @name updateTemplate
     * @request PUT: /api/v1/Survey/template/{id}
     * @secure
     */
    updateTemplate: (data: ISurveyTemplate, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<[]>>({
        url: `/Survey/template/${data?.idTemplate}`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     *  Obtiene todos los templates
     *
     * @tags Survey
     * @name getAllTemplates
     * @request GET: /api/v1/Survey/templates
     * @secure
     */
    getAllTemplates: (params: ParamsSurvey, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<SurveyTemplatesResponse>>
      >({
        url: `/Survey/templates`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     *  Obtiene todos los reportes paginados
     *
     * @tags Survey
     * @name getReports
     * @request GET: /api/v1/Survey/report
     * @secure
     */
    getReports: (params: ParamsSurvey, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PagedList<ISurveyReport>>>({
        url: `/Survey/report`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     *  Obtiene el detalle de un reporte
     *
     * @tags Survey
     * @name getReportById
     * @request GET: /api/v1/Survey/report/{id}
     * @secure
     */
    getReportById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ISurveyDetail[]>>({
        url: `/Survey/report/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     *  Obtiene todos los encuestas respondidas  paginados
     *
     * @tags Survey
     * @name getSurveysAnsweredByTemplate
     * @request GET: /api/v1/Survey/report/survey
     * @secure
     */
    getSurveysAnsweredByTemplate: (
      params: ParamsSurvey,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<ISurveyAsnwered>>>({
        url: `/Survey/report/survey`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * Obtener todas las respuestas de una encuesta específica
     *
     * @tags Survey
     * @name getReportById
     * @request GET: /api/v1/Survey/report/survey/{id}/answers
     * @secure
     */
    getSurveyAnsweredById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ISurveyAnsweredDetail[]>>({
        url: `/Survey/report/survey/${id}/answers`,
        method: 'GET',
        ...config
      })
  },
  kpiParameter: {
    /**
     * Obtiene el listado de los parametros
     *
     * @tags KPIParameter
     * @name kpiParameter
     * @request GET:/api/v1/KPIParameter
     * @secure
     */
    kpiParameter: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<KPIParameter[]>>({
        url: `/KPIParameter`,
        method: 'GET',
        ...config
      }),

    /**
     * Obtiene los filtros según el parámetro
     * @tags KPIParameter
     * @name getFilters
     * @request GET:/api/v1/KPIParameter/filterdata/{ParameterFilterId}
     * @secure
     */
    getFilters: (params: KPIFilter, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/KPIParameter/filterdata/${params.parameterFilterId}`,
        method: 'GET',
        params,
        ...config
      })
  }
};
